export default {
    name: 'Contract',
    props: {
        contract: Object
    },
}
